/**
 * GetPortalLayoutQuery - Fetches shared portal layout data (footer info)
 * Follows CQRS pattern: Query (request) + Handler (executor)
 * Currently returns mock data — will connect to real API later
 */

import type { IQuery, IQueryHandler, IHttpClient } from '@/application/core';
import type { PortalLayoutResponse } from './portal-layout.types';

// ============================================================================
// Query (Request)
// ============================================================================

/**
 * Query to fetch portal layout data (footer version, build, links)
 */
export class GetPortalLayoutQuery implements IQuery<PortalLayoutResponse> {
  readonly type = 'GetPortalLayoutQuery' as const;
}

// ============================================================================
// Mock Data (to be replaced with real API calls)
// ============================================================================

const mockFooterLinks = [
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Terms of Service', href: '/terms' },
  { label: 'Support', href: '/support' },
  { label: 'Documentation', href: '/docs' },
];

// ============================================================================
// Handler
// ============================================================================

/**
 * Handler for GetPortalLayoutQuery
 * Returns shared portal layout metadata (footer data)
 */
export class GetPortalLayoutQueryHandler
  implements IQueryHandler<GetPortalLayoutQuery, PortalLayoutResponse>
{
  constructor(private readonly httpClient: IHttpClient) {}

  async handle(_query: GetPortalLayoutQuery): Promise<PortalLayoutResponse> {
    // TODO: Replace with real API call when backend endpoint is ready
    // const response = await this.httpClient.get<BaseApiResponse<any>>('/api/v1/portal/layout');

    // Simulate network delay
    await new Promise((resolve) => setTimeout(resolve, 200));

    return {
      version: '1.0.0',
      buildNumber: '2024.01.30',
      footerLinks: mockFooterLinks,
    };
  }
}
